import { FETCH_WORKOUT_ALL_TYPES, FETCH_WORKOUT_TYPES } from './ActionTypes';

export function fetchWorkoutTypes(filteredWorkoutTypes) {
    return {
        type: FETCH_WORKOUT_TYPES,
        payload: { filteredWorkoutTypes }
    };
}

export function fetchWorkoutAllTypes() {
    return {
        type: FETCH_WORKOUT_ALL_TYPES
    };
}
